import React from 'react';

interface FinalCTAProps {
    onBookDemo: () => void;
}

const FinalCTA: React.FC<FinalCTAProps> = ({ onBookDemo }) => {
    return (
        <section className="py-10 md:py-16 bg-slate-50 relative overflow-hidden">
            {/* Grid Pattern Backdrop */}
            <div className="absolute inset-0 bg-grid opacity-[0.2] pointer-events-none"></div>

            <div className="container-xl relative z-10 px-4 md:px-0">
                <div className="bg-[#021226] rounded-[3rem] p-8 md:p-14 relative overflow-hidden shadow-2xl flex flex-col items-center text-center group border border-white/5">
                    {/* Dynamic Ambiance */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#FF5C00]/10 blur-[150px] rounded-full pointer-events-none"></div>
                    <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-500/10 blur-[100px] rounded-full pointer-events-none translate-x-1/2 translate-y-1/2"></div>

                    <div className="relative z-10 max-w-3xl">
                        <span className="inline-block px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-[#FF5C00] text-[8px] md:text-[9px] font-black uppercase tracking-[0.4em] mb-6">
                            Join the High-Growth Network
                        </span>

                        <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-white tracking-tighter leading-[1.1] mb-6">
                            Start Your Own <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF5C00] to-orange-300">Success Story Today</span>
                        </h2>

                        <p className="text-slate-400 text-[13px] md:text-lg font-medium leading-relaxed mb-8 max-w-2xl mx-auto">
                            Join 40+ leading furniture brands. Let's build your high-growth visualization ecosystem together.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                            <button
                                onClick={onBookDemo}
                                className="group relative w-full sm:w-auto inline-flex items-center justify-center gap-4 px-10 py-5 bg-[#FF5C00] text-white rounded-2xl font-black text-xs uppercase tracking-widest shadow-[0_20px_40px_-10px_rgba(255,92,0,0.4)] hover:shadow-[0_20px_50px_-10px_rgba(255,92,0,0.6)] hover:-translate-y-1.5 transition-all duration-300"
                            >
                                <span className="relative z-10">Book a Demo</span>
                                <svg className="w-5 h-5 transition-transform group-hover:translate-x-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                                {/* Sheen effect */}
                                <div className="absolute inset-0 rounded-2xl overflow-hidden">
                                    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shimmer"></div>
                                </div>
                            </button>
                        </div>

                        <div className="mt-8 flex items-center justify-center gap-6 opacity-60">
                            <div className="flex flex-col items-center">
                                <span className="text-white font-black text-lg">40+</span>
                                <span className="text-slate-500 text-[8px] font-black uppercase tracking-widest">Active Stores</span>
                            </div>
                            <div className="w-px h-6 bg-white/10"></div>
                            <div className="flex flex-col items-center">
                                <span className="text-white font-black text-lg">14 Days</span>
                                <span className="text-slate-500 text-[8px] font-black uppercase tracking-widest">Setup Time</span>
                            </div>
                            <div className="w-px h-6 bg-white/10"></div>
                            <div className="flex flex-col items-center">
                                <span className="text-white font-black text-lg">94%</span>
                                <span className="text-slate-500 text-[8px] font-black uppercase tracking-widest">Conversion Lift</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FinalCTA;
